module.exports = __webpack_public_path__ + "img/37.e7b7d7f7.svg";